import { P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

type props = {
  children: ReactNode;
  selected?: boolean;
  variant: 'payment-option' | 'package-option';
  dataTestId?: string;
  onClick?: () => void;
  translations?: Record<string, string>;
};

const useStyles = (_translations: Record<string, string> | undefined) =>
  makeStyles()((theme) => ({
    container: {
      cursor: 'pointer',
      position: 'relative',
      border: `1px solid ${theme.palette.primary.light}`,
      paddingLeft: theme.spacing(2),
      borderRadius: Number(theme.shape.borderRadius) * 2,
      transition: 'all 0.1s',
      zIndex: 2,
      '&:hover': {
        outline: `1px solid ${theme.palette.primary.main}`
      },
      '&.selected': {
        outlineOffset: '-3px',
        outline: `3px solid ${theme.palette.primary.main}`
      },
      '&.p2g-option-payment-option, &.p2g-option-package-option': {
        padding: theme.spacing(1, 1, 1, 2)
      }
    }
  }));

const P2GOptionContainer: React.FC<props> = ({ translations, onClick, children, selected, variant, dataTestId }) => {
  const { classes } = useStyles(translations)();
  return (
    <P2GBox
      onClick={onClick}
      dataTestId={dataTestId}
      classNames={[classes.container, selected ? 'selected' : '', `p2g-option-${variant}`]}
    >
      {children}
    </P2GBox>
  );
};
export default P2GOptionContainer;
